export enum ChoiceStatus {
    ACTIVE = 1,
    WON = 2,
    LOST = 3,
    CANCELLED = 4,
}
